import React from 'react';
import { ReactTransliterate } from 'react-transliterate';

function InputTransliterate({
  as = 'input', // 'input' or 'textarea'
  type = 'text',
  className = '',
  id,
  value,
  name,
  onChangeText,
  toLanguage = 'en',
  placeholder = '',
}) {
  const handleChange = (transliteratedValue) => {
    onChangeText(transliteratedValue);
  };

  // Responsive styles
  const inputStyle = {
    width: '100%',
    maxWidth: '100%',
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '16px',
    boxSizing: 'border-box',
    ...(as === 'textarea' ? {
      minHeight: '100px',
      resize: 'both', // Only allow vertical resizing
    } : {
      height: '38px',
    }),
    // Mobile-specific styles
    '@media (max-width: 768px)': {
      fontSize: '14px',
      ...(as === 'textarea' ? { minHeight: '80px' } : { height: '38px' }),
    }
  };

  // Combine with any custom className
  const combinedClassName = `input-transliterate ${className}`.trim();

  if (toLanguage !== 'en') {
    return (
      <ReactTransliterate
        renderComponent={(props) =>
          as === 'textarea' ? (
            <textarea {...props} />
          ) : (
            <input {...props} type={type} />
          )
        }
        className={combinedClassName}
        id={id}
        name={name}
        value={value}
        onChangeText={handleChange}
        fromLanguage="en"
        lang={toLanguage}
        style={inputStyle}
        placeholder={placeholder}
      />
    );
  }

  // Non-transliteration fallback
  return as === 'textarea' ? (
    <textarea
      className={combinedClassName}
      id={id}
      name={name}
      value={value}
      onChange={(e) => onChangeText(e.target.value)}
      style={inputStyle}
      placeholder={placeholder}
    />
  ) : (
    <input
      type={type}
      className={combinedClassName}
      id={id}
      name={name}
      value={value}
      onChange={(e) => onChangeText(e.target.value)}
      style={inputStyle}
      placeholder={placeholder}
    />
  );
}

export default InputTransliterate;